import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import './index.css';
import { App } from './App.js';

import { CHAVE_SUPORTE, emSuporte, registerUnauthorizedHandler, setAccessToken, tokenSalvo } from './lib/api.js';

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

const token = tokenSalvo();
if (token) setAccessToken(token);

registerUnauthorizedHandler(() => {
  setAccessToken(null);
  if (emSuporte()) {
    // Fim da sessão de suporte: não cai no login, que é o da conta do aluno.
    sessionStorage.removeItem(CHAVE_SUPORTE);
    window.location.href = '/suporte/encerrado';
    return;
  }
  localStorage.removeItem('ha_access');
  const p = window.location.pathname;
  const isPublic =
    p === '/' ||
    p.startsWith('/login') ||
    p.startsWith('/cadastro') ||
    p.startsWith('/esqueci-senha') ||
    p.startsWith('/redefinir-senha') ||
    p.startsWith('/ferramenta') ||
    p.startsWith('/certificado/') ||
    p.startsWith('/d/') ||
    p.startsWith('/suporte/');
  if (!isPublic && !p.startsWith('/entrar')) {
    window.location.href = `/login?next=${encodeURIComponent(p + window.location.search)}`;
  }
  if (p.startsWith('/entrar')) {
    window.location.href = `/login${window.location.search}`;
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <TooltipProvider delayDuration={200}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
